(function () {
  if (window.__mmVipInit) return;
  window.__mmVipInit = true;

  function applyPlaceholder() {
    var input = document.querySelector('.klaviyo-form-TRCGwb .klaviyo-emailinput input');
    if (input && input.placeholder !== 'deine@email.de') {
      input.placeholder = 'deine@email.de';
    }
  }

  /* Klaviyo rendert Eingabe- und Erfolgsschritt in denselben Container. Das CSS muss aber
     wissen, welcher gerade sichtbar ist: im Eingabeschritt werden Klaviyos eigene Textzeilen
     ausgeblendet, in der Erfolgsansicht stehen an derselben Position der Bestaetigungssatz
     und der Coupon. Erkennung ueber das E-Mail-Feld, das nur im Eingabeschritt existiert. */
  function syncState() {
    var wrap = document.querySelector('.mm-vip-form-wrap');
    if (!wrap) return;
    var hasInput = !!wrap.querySelector('.klaviyo-form-TRCGwb input[type="email"]');
    var hasForm = !!wrap.querySelector('.klaviyo-form-TRCGwb [data-testid="form-row"]');
    wrap.classList.toggle('is-input', hasInput);
    wrap.classList.toggle('is-done', hasForm && !hasInput);
  }

  function tick() {
    applyPlaceholder();
    syncState();
  }

  function start() {
    tick();
    var observer = new MutationObserver(tick);
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
